// EmptyState — message + optional CTA for empty lists/feeds (Frontend Rules
// §8/§12: list views always have an empty state with message + CTA).
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { InboxIcon } from '../../icons/Icons';
import './empty-state.css';

export function EmptyState({ icon, title, message, action }) {
  const { t } = useTranslation();
  return (
    <div className="empty-state" role="status">
      <span className="empty-state__icon">{icon || <InboxIcon />}</span>
      <p className="empty-state__title">{title ?? t('reusable.emptyState.title')}</p>
      {message && <p className="empty-state__message">{message}</p>}
      {action && <div className="empty-state__action">{action}</div>}
    </div>
  );
}

EmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node,
  message: PropTypes.node,
  /** Call-to-action node (e.g. a button). */
  action: PropTypes.node,
};

export default EmptyState;
